import { Blueprint } from '../../blueprint.class';
import { ToolResult } from '../../types';

export interface RemoveIslandArgs {
	islandId: string;
}

export const removeIslandTool = (blueprint: Blueprint, { islandId }: RemoveIslandArgs): ToolResult => {
	if (!islandId) return { success: false, error: 'Missing islandId. Use list_islands to get valid island IDs.' };

	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) return { success: false, error: 'No active kitchen found.' };

	const islands = kitchen.design?.islands;
	if (!islands) return { success: false, error: 'No islands found in kitchen.' };

	const island = islands.findById(islandId);
	if (!island) return { success: false, error: `Island '${islandId}' not found. Use list_islands to get valid island IDs.` };

	// Check if this is the only island
	if (islands.length === 1) {
		return { success: false, error: 'Cannot remove the only island in the kitchen. Add another island first.' };
	}

	// Obstruction joins (walls, etc.) don't block deletion — only island-to-island joins do.
	if (island.islandConnectionCount > 1) {
		return { success: false, error: `Cannot remove island '${islandId}' - it has multiple connections to other islands.` };
	}

	islands.delete(islandId);

	return { success: true, message: `Island '${islandId}' removed successfully.` };
};
